export default __webpack_public_path__ + "static/media/default.f64003345362d9755e74e139cca9be87.svg";